export default __webpack_public_path__ + "static/bloom-v2-desktop-1863c69183685387a374b6522c2a78d0.mp4";